import React from 'react';
import styled from 'styled-components';
import { FlexColumn, FlexRow } from './html';
import { StyledIcon } from '../../pricing-plans/pricing-plan';

function ErrorLoader({ errors }) {
  const errorText = errors.length === 1 ? 'An error has occurred' : 'Multiple errors have occurred';

  return (
    <Wrapper>
      <p>{errorText}</p>
      <br />
      <FlexColumn>
        {errors.map((error) => (
          <FlexRow center>
            <Check icon="cross" />
            {error}
          </FlexRow>
        ))}
      </FlexColumn>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50rem;
  flex-direction: column;
  text-align: center;
`;

const Check = styled(StyledIcon)`
  position: unset;
  height: 1rem;
  width: 1rem;
  color: #e91e63;
  font-size: 1.25rem;
`;

export default ErrorLoader;
